<template>
  <div class="content">
    <div class="title">
      <p class="line"></p>
      <p class="titleCnt">视频中心</p>
      <p class="titleEnt">VIDEO CENTER</p>
    </div>

    <el-row>
      <el-col :span="7">
        <div>
          <ul>
            <li
              class="item"
              @click="openVideo(item)"
              v-for="(item, index) in list"
              style="
                margin-bottom: 15px;
                cursor: pointer;
                background: #fff;
                padding: 10px;
              "
              :key="index"
            >
              <el-row>
                <el-col :span="8">
                  <div>
                    <img
                      width="100%"
                      height="80px"
                      :src="'/attachmentDir/' + item.coverPictureFiles"
                    />
                  </div>
                </el-col>
                <el-col :span="16" style="padding-left: 15px; font-size: 14px">
                  <div
                    class="beyondEllipsis"
                    style="
                      text-decoration: underline;
                      color: #1890ff;
                      font-size: 18px;
                      margin-bottom: 5px;
                    "
                  >
                    {{ item.resourceTitle }}
                  </div>
                  <div
                    class="beyondEllipsis"
                    style="margin-bottom: 5px"
                    :title="item.resourceContent"
                  >
                    简介：{{ item.resourceContent }}
                  </div>
                  <div style="color: #999; font-size: 12px">
                    <span>来源：</span>
                    <span style="margin-right: 30px">{{
                      ["资源中心", "行业动态", "学习中心"][item.channel]
                    }}</span>
                  </div>
                  <div style="color: #999; font-size: 12px">
                    <span>发布时间</span>
                    ：{{ item.createDate }}
                  </div>
                </el-col>
              </el-row>
            </li>
          </ul>
        </div>
      </el-col>
      <el-col :span="17">
        <div class="grid-content bg-purple-light" style="padding-left: 30px">
          <video
            :src="url"
            ref="video"
            controls="controls"
            style="width: 100%; height: 500px; outline: none"
          ></video>
        </div>
        <div style="font-size: 25px; line-height: 50px; padding-left: 30px">
          {{ name }}
        </div>
      </el-col>
    </el-row>
    <login-view ref="loginView" />
  </div>
</template>

<script>
import { resourceQy, videoResourceQy, resourceOpt, login } from "@/api/home";
import router from "@/router/index";
let playedTimes = null;
import loginView from "@/components/loginView";
export default {
  data() {
    return {
      list: [],
      url: "",
      http: "",
      name: "",
      currentTime: 0,
      employeeResourceId: "",
      play: false,
    };
  },
  mounted() {
    this.init();
    this.getList();
    this.$refs.video.onplay = this.onplay;
    this.$refs.video.onpause = this.onpause;
    login({ op: "getSessionUser" })
      .then((response) => {
        if (!response) {
          this.$refs.loginView.show();
        }
      })
      .catch((error) => {});
  },
  components: {
    loginView,
  },
  methods: {
    getPlayedTimes() {
      resourceQy({
        op: "getLastEmployeeResourceByResourceId",
        resourceId: this.$route.query.resourceId,
      }).then((res) => {
        this.currentTime = res.browseDuration;
        this.$refs.video.currentTime = this.currentTime;
      });
    },
    onpause(val) {},
    onplay(val) {
      if (this.play) {
        return;
      }
      resourceOpt({
        op: "startPlay",
        resourceId: this.$route.query.resourceId,
      }).then((res) => {
        if (res.success) {
          this.play = true;
          this.employeeResourceId = res.data.employeeResourceId;
        } else {
          this.employeeResourceId = "";
        }
      });
    },
    init() {
      clearInterval(playedTimes);
      playedTimes = setInterval(() => {
        if (this.$refs.video && this.employeeResourceId) {
          resourceOpt({
            op: "savePlayProgress",
            employeeResourceId: this.employeeResourceId,
            playedTimes: Math.floor(this.$refs.video.currentTime),
          }).then((res) => {
            console.log(res);
          });
        } else {
          clearInterval(playedTimes);
        }
      }, 10000);
      this.url = this.http + "/attachmentDir/" + this.$route.query.url;
      this.getPlayedTimes();
      this.name = this.$route.query.name;
    },
    openVideo(item) {
      this.$router.push({
        path: "/videoPlay",
        query: {
          id: this.$route.query.id,
          url: item.attachment.filesName,
          resourceClassId: this.$route.query.resourceClassId,
          name: item.resourceTitle,
          resourceId: item.resourceId,
        },
      });
      this.play = false;
      this.init();
    },
    getList() {
      videoResourceQy({
        op: "findPageVideoResource",
        pageNo: 1,
        pageSize: 10,
        resourceClassId: this.$route.query.resourceClassId,
      }).then((res) => {
        this.list = res.result || [];
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  margin: 0 auto;

  .item:hover {
    background: #f7f7f7;
  }
  img {
    border: none;
  }
  .title {
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 30px;
    position: relative;
    .titleEnt {
      color: #999;
      line-height: 30px;
    }
    .titleCnt {
      position: absolute;
      top: -23px;
      left: 508px;
      background: #fff;
      padding: 0 30px;
    }
    .line {
      width: 300px;
      height: 2px;
      background: #ddd;
      margin: 25px auto;
    }
  }
}
</style>